export default __webpack_public_path__ + "static/media/29.0c0edf2c.png";